const DITypes = {
  SocketConnection: Symbol('SocketConnection'),
  SocketAdapter: Symbol('SocketAdapter'),
  SocketClient: Symbol('SocketClient'),
  SocketDispatcher: Symbol('SocketDispatcher'),
};

export default DITypes;
